export function LogoMark({ size = 36, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label="LogiTech Nexus mark"
      data-testid="logo-mark"
    >
      <defs>
        <linearGradient id="ln-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3B82F6" />
          <stop offset="1" stopColor="#06B6D4" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill="#0B0F19" stroke="rgba(59,130,246,0.25)" />
      <g stroke="url(#ln-g)" strokeWidth="3" strokeLinecap="round">
        <line x1="20" y1="46" x2="20" y2="18" />
        <line x1="20" y1="18" x2="44" y2="46" />
        <line x1="44" y1="46" x2="44" y2="18" />
      </g>
      <circle cx="20" cy="46" r="4.5" fill="#3B82F6" />
      <circle cx="20" cy="18" r="4.5" fill="#60A5FA" />
      <circle cx="44" cy="18" r="4.5" fill="#06B6D4" />
      <circle cx="44" cy="46" r="4.5" fill="#22D3EE" />
    </svg>
  );
}

export default function Logo({ dark = true, markOnly = false, size = 36 }) {
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="logo">
      <LogoMark size={size} />
      {!markOnly && (
        <span
          className={`font-display font-bold tracking-tight text-lg leading-none ${
            dark ? "text-white" : "text-slate-900"
          }`}
        >
          LogiTech{" "}
          <span className="text-accent-gradient">Nexus</span>
        </span>
      )}
    </span>
  );
}
